import React, { useEffect, useRef } from "react";
import "./App.css";
import Loader from "./components/Loader";
import UnderMaintenance from "./pages/UnderMaintenance/UnderMaintenance";
import { useGetMaintenanceQuery } from "./redux/api/Admin/AdminApi";
import Router from "./routes";
import ScrollToTop from "./utils/ScrollToTop";
import { Navigate, useLocation } from "react-router-dom";

function App() {
  const { data, isLoading, isError } = useGetMaintenanceQuery();
  const location = useLocation();
  const prevPathnameRef = useRef(location.pathname);

  useEffect(() => {
    const prevPath = prevPathnameRef.current;
    const currentPath = location.pathname;

    if (prevPath !== currentPath) {
      // Clear individual tests selections if navigating away
      if (prevPath === "/all-Individual-tests") {
        sessionStorage.removeItem("individual_selectedTests");
        sessionStorage.removeItem("individual_selectedTestsData");
        sessionStorage.removeItem("individual_pendingBookAction");
        sessionStorage.removeItem("individual_pendingBookNowTest");
      }
      // Clear package tests selections if navigating away
      if (prevPath === "/all-package-tests") {
        sessionStorage.removeItem("package_selectedPackages");
        sessionStorage.removeItem("package_selectedPackagesData");
        sessionStorage.removeItem("package_pendingBookAction");
        sessionStorage.removeItem("package_pendingBookNowPackage");
      }
      // Clear search selections and inputs if navigating away
      if (prevPath === "/search") {
        sessionStorage.removeItem("search_searchTerm");
        sessionStorage.removeItem("search_showResults");
        sessionStorage.removeItem("search_selectedTests");
        sessionStorage.removeItem("search_selectedTestsData");
        sessionStorage.removeItem("search_pendingBookAction");
        sessionStorage.removeItem("search_pendingBookNowTest");
      }
      prevPathnameRef.current = currentPath;
    }
  }, [location.pathname]);

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    if (location.pathname.startsWith("/admin")) {
      return (
        <>
          <ScrollToTop />
          <Router />
        </>
      );
    }
    return <UnderMaintenance />;
  }

  const isActive = data?.isActive ?? false;
  if (
    isActive &&
    !location.pathname.startsWith("/admin") &&
    !location.pathname.startsWith("/app")
  ) {
    if (location.pathname !== "/") {
      return <Navigate to="/" replace />;
    }
    return <UnderMaintenance />;
  }
  return (
    <>
      <ScrollToTop />
      <Router />
    </>
  );
}

export default App;
